import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"
import Figure from "../figure"
import Artifact from "../artifact"

const Diary = () => (
  <>
    <Artifact>
      <StyledTranslation>
        <small>Translation:</small>
        <span>Thursday 25-03-2021 all migrants will be released in order to better prepare for the month of Ramadan. &ldquo;The lord is miraculous and may his grace continue to protect all migrants around the world and especially those from Libya in particular.&rdquo;</span>
      </StyledTranslation>
    </Artifact>
    <Figure
      caption={<>An entry in Tokam Martin<br /> Luther&rsquo;s prison diary.</>}
      date="March 25, 2021"
    >
      <StaticImage
        src="../../../images/mabani/luther-diary-1.png"
        alt=""
      />
    </Figure>
  </>
)
export default Diary;
export { Diary }

const StyledTranslation = styled.div`
  position: relative;
  padding-top: 6.5em;
  small {
    font-family: var(--font-caption);
    font-weight: var(--font-caption-weight);
    text-transform: uppercase;
    font-size: 0.625em;
    letter-spacing: 0.05em;
    color: var(--theme-text-against-dark-medium);
  }
  span {
    display: block;
    line-height: 1.4;
    font-size: 0.9375em;
    color: var(--theme-text-against-dark-medium);
  }
`